/**
 * 统一日志工具
 * 生产环境自动禁用调试日志，避免敏感信息泄露
 */

const isDev = process.env.NODE_ENV === 'development'

/**
 * 日志工具类
 */
export const logger = {
	/**
	 * 普通日志（仅开发环境）
	 */
	log: (...args) => {
		if (isDev) {
			console.log(...args)
		}
	},

	/**
	 * 警告日志（仅开发环境）
	 */
	warn: (...args) => {
		if (isDev) {
			console.warn(...args)
		}
	},

	/**
	 * 错误日志（所有环境保留，但需要脱敏）
	 */
	error: (...args) => {
		// 错误日志保留，但需要脱敏处理
		const sanitizedArgs = args.map(arg => {
			if (typeof arg === 'object' && arg !== null) {
				// 脱敏处理：移除敏感字段
				const sanitized = { ...arg }
				if (sanitized.password) sanitized.password = '***'
				if (sanitized.Password) sanitized.Password = '***'
				if (sanitized.token) sanitized.token = '***'
				if (sanitized.Token) sanitized.Token = '***'
				if (sanitized.accountInfo) sanitized.accountInfo = '***'
				return sanitized
			}
			return arg
		})
		console.error(...sanitizedArgs)
	},

	/**
	 * 信息日志（仅开发环境）
	 */
	info: (...args) => {
		if (isDev) {
			console.info(...args)
		}
	},

	/**
	 * 调试日志（仅开发环境）
	 */
	debug: (...args) => {
		if (isDev) {
			console.debug(...args)
		}
	}
}

export default logger

